<template>
  <div class="settings-users-container m-4">
    <div
      class="d-flex flex-row justify-content-between align-items-center mb-3"
    >
      <h5 class="mb-0">Users ({{ items.length }})</h5>
      <div class="ml-auto mr-3" style="width: 300px">
        <b-input v-model="search" placeholder="Search..." />
      </div>
      <b-button class="pt-2 pb-2" size="sm" @click="addUser" variant="primary"
        >New</b-button
      >
    </div>
    <grid
      :groupFeature="false"
      :columns="columns"
      :autoHeight="true"
      :data="items"
      :columnLines="false"
      :searchFeature="true"
      :stripeFeature="false"
    ></grid>
    <b-modal
      centered
      ref="form-modal"
      :title="formId ? 'Edit User' : 'Add User'"
      header-bg-variant="primary"
      header-text-variant="white"
      @ok="submitUser"
      no-close-on-backdrop
      size="lg"
      header-class="bg-purple"
    >
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="secondary" @click="cancel()">
          Cancel
        </b-button>
        <b-button variant="primary" @click="ok()">
          Save
        </b-button>
      </template>
      <template v-if="formId" v-slot:modal-header>
        <div class="w-100 d-flex flex-row justify-content-between">
          <h5 class="modal-title">Edit User</h5>
          <div class="d-flex justify-content-end">
            <div class="d-flex align-items-center">
              <button
                type="button"
                aria-label="Close"
                class="close text-white"
                @click="$refs['form-modal'].hide"
              >
                ×
              </button>
            </div>
          </div>
        </div>
      </template>
      <image-cropper
        :image="fileChoosed"
        v-model="cropImage"
        @cropped="saveCroppedImage"
      />
      <b-row>
        <b-col>
          <b-row>
            <b-col>
              <div class="d-flex flex-row align-items-center mb-2">
                <div
                  class="picture-preview mr-4"
                  style="width: 152px; height: 152px;"
                >
                  <img
                    :src="
                      form.avatar
                        ? form.avatar
                        : require(`../../assets/avatar-example.png`)
                    "
                  />
                </div>
                <b-form-group
                  :state="avatarErrors.length == 0 ? null : false"
                  :invalid-feedback="avatarErrors.join(', ')"
                >
                  <input
                    ref="fileUpload"
                    @change="cropFile"
                    type="file"
                    accept="image/*"
                    hidden
                  />
                </b-form-group>
                <label
                  class="mb-0 text-primary fileUploadLb"
                  @click="chooseFile()"
                  >Choose file</label
                >
              </div>
            </b-col>
            <b-col>
              <b-form-group style="margin-top:50px;">
                <b-form-checkbox v-model="form.twoFactorAuth">
                  Enable Two Step authentication
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label="Has access to"
                v-slot="{ ariaDescribedby }"
                :state="formErrors.accessToLocations.length == 0 ? null : false"
                :invalid-feedback="formErrors.accessToLocations.join(', ')"
              >
                <div style="max-height:150px; overflow: auto;">
                  <b-form-checkbox-group
                    v-model="form.accessToLocations"
                    :options="locations"
                    :aria-describedby="ariaDescribedby"
                    stacked
                  ></b-form-checkbox-group>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            label="First Name"
            :state="formErrors.firstName.length == 0 ? null : false"
            :invalid-feedback="formErrors.firstName.join(', ')"
          >
            <template v-slot:label>
              First Name <span class="text-danger">*</span>
            </template>
            <b-form-input
              v-model="form.firstName"
              trim
              maxLength="50"
              :state="formErrors.firstName.length == 0 ? null : false"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Middle Name">
            <b-form-input
              v-model="form.middleName"
              trim
              maxLength="50"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Preferred Name">
            <b-form-input
              trim
              v-model="form.preferredName"
              maxLength="100"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label="Last Name"
            :state="formErrors.lastName.length == 0 ? null : false"
            :invalid-feedback="formErrors.lastName.join(', ')"
          >
            <template v-slot:label>
              Last Name <span class="text-danger">*</span>
            </template>
            <b-form-input
              v-model="form.lastName"
              trim
              maxLength="50"
              :state="formErrors.lastName.length == 0 ? null : false"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4">
          <b-form-group
            label="Role"
            :state="formErrors.roleId.length == 0 ? null : false"
            :invalid-feedback="formErrors.roleId.join(', ')"
          >
            <template v-slot:label>
              Role <span class="text-danger">*</span>
            </template>
            <b-form-select
              v-model="form.roleId"
              :options="roles"
              :state="formErrors.roleId.length == 0 ? null : false"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            label="Email"
            :state="formErrors.email.length == 0 ? null : false"
            :invalid-feedback="formErrors.email.join(', ')"
          >
            <template v-slot:label>
              Email <span class="text-danger">*</span>
            </template>
            <b-form-input
              v-model="form.email"
              trim
              maxLength="200"
              :state="formErrors.email.length == 0 ? null : false"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label="Mobile Phone Number"
            :state="formErrors.phone.length == 0 ? null : false"
            :invalid-feedback="formErrors.phone.join(', ')"
          >
            <phone-input
              ref="phoneInput"
              defaultCountry="US"
              v-model="form.phone"
              trim
              :state="formErrors.phone.length == 0 ? null : false"
            ></phone-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label="Fax"
            :state="formErrors.fax.length == 0 ? null : false"
            :invalid-feedback="formErrors.fax.join(', ')"
          >
            <phone-input
              ref="faxInput"
              defaultCountry="US"
              v-model="form.fax"
              trim
              :state="formErrors.fax.length == 0 ? null : false"
            ></phone-input>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      centered
      ref="password-form-modal"
      title="Change Password"
      header-bg-variant="primary"
      header-text-variant="white"
      @ok="submitPasswordChange"
      no-close-on-backdrop
      header-class="bg-purple"
    >
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="secondary" @click="cancel()">
          Cancel
        </b-button>
        <b-button variant="primary" @click="ok()">
          Save
        </b-button>
      </template>
      <b-form-group
        label="New Password"
        :invalid-feedback="passwordFormError"
        :state="passwordFormError == 0 ? null : false"
      >
        <b-form-input v-model="passwordForm.newPassword" trim></b-form-input>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Grid from "../../third_party/grid/Grid.vue";
import userServer from "../../server/user";
import avatarServer from "../../server/avatar";
import {
  validateRequired,
  validateEmail,
  validatePhoneNumber
} from "../../helpers/validation";
import { resizeImage } from "../../helpers/file";

import ImageCropper from "../controls/ImageCropper.vue";
import PhoneInput from "../controls/PhoneInput.vue";

export default {
  name: "UserCrud",
  components: {
    Grid,
    ImageCropper,
    PhoneInput
  },
  props: ["showing"],
  data() {
    return {
      list: [],
      formId: null,
      form: {
        firstName: "",
        lastName: "",
        roleId: null,
        middleName: "",
        preferredName: "",
        phone: "",
        email: "",
        fax: "",
        twoFactorAuth: false,
        avatar: null,
        accessToLocations: []
      },
      formErrors: {
        firstName: [],
        lastName: [],
        roleId: [],
        phone: [],
        email: [],
        fax: [],
        accessToLocations: []
      },
      fileChoosed: null,
      cropImage: false,
      passwordForm: {
        userId: "",
        newPassword: ""
      },
      passwordFormError: "",
      avatarErrors: [],
      search: "",
      advancedOptions: localStorage.getItem("advanced") === "true"
    };
  },
  mounted() {
    this.getUsers();
    this.fetchRoles();
    this.fetchStates();
    this.fetchLocations();
  },
  methods: {
    ...mapActions("layout", [
      "showAlertSuccess",
      "showError",
      "fetchCurrentUser"
    ]),
    ...mapActions("layout", ["fetchRoles"]),
    ...mapActions("client", ["fetchStates", "fetchLocations"]),
    async getUsers() {
      let users = await userServer.queryImproved();
      if (this.currentUser.role.name != "Tech Staff") {
        this.list = users.filter(u => u.role.name != "Tech Staff");
      } else {
        this.list = users;
      }
    },
    validateSubmit() {
      let withoutErrors = true;
      this.formErrors.accessToLocations = [];
      if (this.form.accessToLocations.length == 0) {
        this.formErrors.accessToLocations.push(
          "Must select at least 1 location"
        );
        withoutErrors = false;
      }

      this.formErrors.firstName = [];
      if (!validateRequired(this.form.firstName)) {
        this.formErrors.firstName.push("This field is required");
        withoutErrors = false;
      }
      this.formErrors.lastName = [];
      if (!validateRequired(this.form.lastName)) {
        this.formErrors.lastName.push("This field is required");
        withoutErrors = false;
      }

      this.formErrors.roleId = [];
      if (!validateRequired(this.form.roleId)) {
        this.formErrors.roleId.push("This field is required");
        withoutErrors = false;
      }

      this.formErrors.email = [];
      if (!validateRequired(this.form.email)) {
        this.formErrors.email.push("This field is required");
        withoutErrors = false;
      }
      if (this.form.email && !validateEmail(this.form.email)) {
        this.formErrors.email.push("This field must have a valid email format");
        withoutErrors = false;
      }

      this.formErrors.phone = [];
      if (
        this.form.phone.trim().length >
          this.activePhoneCountry.dialCode.length + 1 &&
        !validatePhoneNumber(this.form.phone)
      ) {
        this.formErrors.phone.push("Invalid phone number");
        withoutErrors = false;
      }

      this.formErrors.roleId = [];
      if (!validateRequired(this.form.roleId)) {
        this.formErrors.roleId.push("This field is required");
        withoutErrors = false;
      }

      this.formErrors.fax = [];
      if (
        this.form.fax.trim().length >
          this.activeFaxCountry.dialCode.length + 1 &&
        !validatePhoneNumber(this.form.fax)
      ) {
        this.formErrors.fax.push("Invalid phone number");
        withoutErrors = false;
      }
      return withoutErrors;
    },
    async submitUser(modalEvent) {
      modalEvent.preventDefault();
      const result = this.validateSubmit();
      if (result) {
        const formData = {
          ...this.form,
          phone:
            this.form.phone.trim().length >
            this.activePhoneCountry.dialCode.length + 1
              ? this.form.phone
              : "",
          fax:
            this.form.fax.trim().length >
            this.activeFaxCountry.dialCode.length + 1
              ? this.form.fax
              : "",
          avatarContent:
            this.fileChoosed && this.form.avatar ? this.form.avatar : null
        };
        let resultPromise = null;
        if (this.formId) {
          resultPromise = userServer.update(this.formId, formData);
        } else {
          resultPromise = userServer.create(formData);
        }
        resultPromise
          .then(() => {
            this.getUsers();
            this.fetchCurrentUser();
            this.showAlertSuccess();
            this.$refs["form-modal"].hide();
          })
          .catch(error => {
            this.showError({
              message: error.response.data
            });
          });
      }
    },
    addUser() {
      this.formId = null;
      this.form = {
        firstName: "",
        lastName: "",
        roleId: null,
        middleName: "",
        preferredName: "",
        phone: "",
        email: "",
        fax: "",
        twoFactorAuth: false,
        providerInfo: false,
        avatar: null,
        accessToLocations: []
      };
      this.$refs["form-modal"].show();
    },
    chooseFile() {
      this.$refs.fileUpload.value = "";
      this.$refs.fileUpload.click();
    },
    validateCropFile(file) {
      let withoutErrors = true;

      const fileSize = (file.size / 1024 / 1024).toFixed(4);

      this.avatarErrors = [];
      if (fileSize > 20) {
        this.avatarErrors.push("Image max size 20 mb");
        withoutErrors = false;
      }

      if (!file.type.includes("image/")) {
        this.avatarErrors.push("Only image file supported");
        withoutErrors = false;
      }

      return withoutErrors;
    },
    async cropFile() {
      const file = this.$refs.fileUpload.files[0];
      const result = this.validateCropFile(file);
      if (result) {
        const blobUrl = URL.createObjectURL(file);
        const blob = await resizeImage(blobUrl, 1920, 1920);
        this.fileChoosed = blob;
        this.cropImage = true;
      }
    },
    saveCroppedImage(croppedBase64) {
      this.form.avatar = croppedBase64;
    },
    async submitPasswordChange(modalEvent) {
      modalEvent.preventDefault();
      if (this.validatePasswordChange()) {
        await userServer.changeUserPassword(this.passwordForm.userId, {
          newPassword: this.passwordForm.newPassword
        });

        this.$refs["password-form-modal"].hide();
        this.showAlertSuccess();
      }
    },
    validatePasswordChange() {
      this.passwordFormError = "";
      if (!validateRequired(this.passwordForm.newPassword)) {
        this.passwordFormError = "This field is required";
        return false;
      }

      if (this.passwordForm.newPassword.length < 8) {
        this.passwordFormError =
          "The password must be at least 8 characters long";
        return false;
      }

      return true;
    }
  },
  computed: {
    ...mapState("layout", {
      currentUser: state => state.currentUser,
      roles(state) {
        return state.roles
          .filter(
            role =>
              this.currentUser.role.name == "Tech Staff" ||
              role.name !== "Tech Staff"
          )
          .map(role => ({
            value: role.id,
            text: role.name
          }));
      },
      systemSetting: state => state.systemSetting
    }),
    ...mapState("client", {
      locations: state =>
        state.locations.map(l => ({
          text: l.name,
          value: l.id
        }))
    }),
    items() {
      let items = this.list.slice();

      if (this.search) {
        const itemName = item => this.formatUser(item);
        const caseInsensitiveIncludes = (text, char) =>
          text?.toUpperCase().includes(char?.toUpperCase());

        items = items.filter(
          item =>
            caseInsensitiveIncludes(itemName(item), this.search) ||
            caseInsensitiveIncludes(item.phone, this.search) ||
            caseInsensitiveIncludes(item.email, this.search)
        );
      }

      return items;
    },
    columns() {
      let columns = [
        {
          text: "Name",
          field: "name",
          flex: 1,
          editor: false,
          type: "template",
          template: data => this.formatUser(data.record.data),
          sortable(a, b) {
            return a.lastName
              .toLowerCase()
              .localeCompare(b.lastName.toLowerCase());
          }
        },
        {
          text: "Role",
          field: "role",
          flex: 1,
          editor: false,
          type: "template",
          template: data =>
            data.record.data.role ? data.record.data.role.name : "",
          sortable(a, b) {
            return a.role.name.localeCompare(b.role.name);
          }
        },
        {
          text: "Mobile Phone Number",
          field: "phone",
          flex: 1,
          editor: false,
          type: "template",
          template: data => data.record.data.phone
        },
        {
          text: "Email",
          field: "email",
          flex: 1,
          editor: false,
          type: "template",
          template: data => data.record.data.email,
          sortable(a, b) {
            return a.email.toLowerCase().localeCompare(b.email.toLowerCase());
          }
        },
        {
          text: "",
          type: "action",
          cellCls: "pointer-cell",
          field: "action",
          align: "right",
          width: 200,
          actions: [
            {
              tooltip: "Assign password",
              renderer: () =>
                this.currentUser.role.systemPermissions.settings.access
                  .setPasswords
                  ? `<span class="b-action-item action-link-text assign-password text-primary">Assign password</span>`
                  : `<span class="text-secondary mr-3">Assign password</span>`,
              onClick: async ({ record }) => {
                this.passwordForm = {
                  userId: record.id,
                  newPassword: ""
                };
                this.$refs["password-form-modal"].show();
              }
            },
            {
              tooltip: "Edit",
              renderer: () =>
                `<img class="b-action-item" src="${
                  this.isStandalone()
                    ? `/icons/edit.svg`
                    : `/desktop/icons/edit.svg`
                }">`,
              onClick: async ({ record }) => {
                this.formId = record.id;
                const form = await userServer.get(this.formId);
                let avatar = null;
                if (form.avatarId) {
                  try {
                    avatar = await avatarServer.downloadUrl(form.avatarId);
                  } catch {
                    //
                  }
                }
                this.form = {
                  firstName: form.firstName,
                  lastName: form.lastName,
                  roleId: form.role ? form.role.id : null,
                  middleName: form.middleName,
                  preferredName: form.preferredName,
                  phone: form.phone,
                  email: form.email,
                  fax: form.fax,
                  twoFactorAuth: form.twoFactorAuth,
                  providerInfo: form.providerInfo,
                  avatar: avatar,
                  accessToLocations: form.accessToLocations.map(l => l.id)
                };
                this.$refs["form-modal"].show();
              }
            },
            {
              tooltip: "Delete",
              renderer: () =>
                `<img class="b-action-item ml-2 mr-1" src="${
                  this.isStandalone()
                    ? `/icons/delete.svg`
                    : `/desktop/icons/delete.svg`
                }">`,
              onClick: ({ record }) => {
                this.$dialog
                  .confirm(
                    {
                      title: "Are you sure you want to delete this record?"
                    },
                    {
                      view: "confirm-delete"
                    }
                  )
                  .then(async () => {
                    await userServer.delete(record.id);
                    this.getUsers();
                    this.showAlertSuccess();
                  })
                  .catch(function() {});
              }
            }
          ]
        }
      ];
      return columns;
    },
    activePhoneCountry() {
      return this.$refs.phoneInput.$refs.telInput.activeCountry;
    },
    activeFaxCountry() {
      return this.$refs.faxInput.$refs.telInput.activeCountry;
    }
  },
  watch: {
    showing: function(newValue) {
      if (newValue) {
        this.fetchLocations();
      }
    }
  }
};
</script>

<style scoped>
.fileUploadLb:hover {
  cursor: pointer;
}
</style>

<style>
.settings-users-container .b-grid-container .b-container {
  max-height: calc(100vh - 281px) !important;
}
</style>
